export default {
  title: {
    en: 'Thank you for staying with us! <br class="exceptMobile" />We’ve applied your discount.',
  },
  ok: {
    en: 'Okay',
  },
}
